import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';
import { Parallax } from 'react-parallax';

const styles = require('./section-layout.styles.scss');


export class SectionLayout extends React.Component {
  static defaultProps = {
    className: '',
    background: null,
    wide: false
  }

  static propTypes = {
    background: PropTypes.string,
  }

  render() {
    const { background, wide, children, className, ...props } = this.props;
    const parallaxDisabled = !background;
    const classname = classnames(className, styles.Section);
    const canvasClassName = classnames(styles.ContentCanvas, {
      [styles.wide]: wide,
      [styles.background]: !!background
    });

    return (
      <div {...props} className={classname}>
        <Parallax bgImage={background} strength={150} disabled={parallaxDisabled}>
          <div className={canvasClassName}>
            { children }
          </div>
        </Parallax>
      </div>
    );
  }

  get computedStyle() {
    const style = {};
    const { background } = this.props;

    if (background) {
      style.background = `url(${background})`;
      style['background-attachment'] = 'fixed';
      style['background-position'] = 'center center';
      style['background-size'] = 'cover';
    }

    return style;
  }
}



// WEBPACK FOOTER //
// ./src/layouts/section/section.layout.jsx